module.exports = __webpack_public_path__ + "449721692b8d9b4b3f9f94da1118761f.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-blackitalic.woff
 ** module id = 22
 ** module chunks = 0
 **/